import { render, staticRenderFns } from "./ListCategoryPage.vue?vue&type=template&id=414cab22&"
import script from "./ListCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ListCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports